<template>
  <div
    class="accruals-estimates-view-switcher"
    role="tablist"
    aria-label="Accruals workbench view"
    :data-testid="`${testIdPrefix}__view-switcher`"
  >
    <div class="accruals-estimates-view-switcher__track">
      <button
        v-for="tab in tabs"
        :key="tab.id"
        type="button"
        role="tab"
        class="accruals-estimates-view-switcher__segment"
        :class="{ 'accruals-estimates-view-switcher__segment--active': tab.id === value }"
        :aria-selected="tab.id === value ? 'true' : 'false'"
        :disabled="disabled"
        :data-testid="`${testIdPrefix}__view-switcher--${tab.id}`"
        @click="$emit('input', tab.id)"
      >
        {{ tab.label }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccrualsEstimatesViewSwitcher',
  props: {
    value: { type: String, required: true },
    tabs: { type: Array, required: true },
    disabled: { type: Boolean, default: false },
    testIdPrefix: { type: String, default: 'accruals-estimates-page' },
  },
};
</script>

<style lang="scss" scoped>
@import './AccrualsEstimatesViewSwitcher.scss';
</style>
